import { useEffect, useState } from 'react';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';

import UserStore from 'stores/UserStore';
import allUserGroups from 'enum/userGroups';
import { shouldApplyFingerprintHeaders } from 'utils/helpers';


function useFingerprintInfo(userId) {
  const [fingerprintData, setFingerprintData] = useState(null);
  const hasFingerprintCF = UserStore.hasCF(allUserGroups.FINGERPRINT);
  const { getData } = useVisitorData({ linkedId: userId }, { immediate: false });

  useEffect(() => {
    if (hasFingerprintCF && userId && shouldApplyFingerprintHeaders()) {
      const fetchData = async() => {
        const data = await getData();
        setFingerprintData(data);
      };

      try {
        fetchData();
      } catch (error) {
        // nothing to do
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return fingerprintData;
}

export default useFingerprintInfo;
